<template>
    <svg aria-hidden="true" focusable="false" v-if="size === 'small'" class="heart" width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle opacity="0.85" cx="17" cy="17" r="16.5" stroke="#9D9FA2" />
        <path
            d="M17.489 24C17.3883 24 17.3013 23.9766 17.2326 23.9297C15.3466 22.6653 13.6756 21.4946 12.2657 19.9351C11.1166 18.6661 10.4163 17.3829 10.1187 16.0108C9.91727 15.0789 9.9722 14.2032 10.2835 13.4024C10.7001 12.3253 11.5424 11.5151 12.5907 11.1826C12.9432 11.0703 13.3094 11.014 13.6802 11.014C14.4264 11.014 15.1589 11.2435 15.8043 11.679C16.3628 12.0584 16.8481 12.5594 17.283 13.2197L17.4935 13.5382L17.727 13.2338C18.0154 12.8498 18.2992 12.4798 18.6334 12.152C19.4071 11.3887 20.2906 11 21.2611 11C21.5495 11 21.847 11.0375 22.14 11.103C23.6827 11.4636 24.8547 12.8685 24.9828 14.5122C25.0744 15.6268 24.7997 16.7554 24.1543 17.9636C23.5088 19.1671 22.6115 20.2396 21.49 21.1481C20.5927 21.8739 19.6589 22.5576 18.7524 23.2179L18.7021 23.2554C18.4091 23.4708 18.1161 23.6816 17.8277 23.897C17.7362 23.9625 17.608 24 17.489 24Z"
            stroke="black"
            stroke-miterlimit="10" />
    </svg>

    <svg aria-hidden="true" focusable="false" v-else class="heart" width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="22.5" cy="22.5" r="22" stroke="#9D9FA2" />
        <path
            d="M22.4864 31.7647C22.362 31.7647 22.2545 31.7361 22.1697 31.6789C19.8399 30.1341 17.7758 28.7038 16.0341 26.7986C14.6147 25.2481 13.7495 23.6805 13.3819 22.0042C13.1331 20.8656 13.201 19.7957 13.5855 18.8174C14.1001 17.5015 15.1406 16.5117 16.4356 16.1055C16.871 15.9682 17.3234 15.8995 17.7815 15.8995C18.7032 15.8995 19.608 16.1799 20.4053 16.712C21.0953 17.1754 21.6947 17.7875 22.2319 18.5942L22.492 18.9833L22.7804 18.6114C23.1367 18.1423 23.4873 17.6903 23.9001 17.2898C24.8558 16.3572 25.9472 15.8824 27.1461 15.8824C27.5023 15.8824 27.8699 15.9281 28.2318 16.0082C30.1375 16.4488 31.5852 18.1652 31.7435 20.1733C31.8566 21.535 31.5173 22.9138 30.72 24.3899C29.9226 25.8603 28.8143 27.1705 27.4288 28.2804C26.3204 29.1672 25.1668 30.0025 24.0471 30.8092L23.9849 30.855C23.623 31.1182 23.2611 31.3757 22.9048 31.6388C22.7917 31.7189 22.6334 31.7647 22.4864 31.7647Z"
            stroke="black"
            stroke-miterlimit="10" />
    </svg>
</template>

<script setup>
    const props = defineProps({
        size: {
            type: String,
            required: false,
            default: 'small',
        },
    });
</script>

<style lang="scss" scoped>
    .heart path {
        stroke: $black;
        transition:
            stroke 0.25s ease-in-out,
            fill 0.25s ease-in-out;
    }

    .in-favorites {
        .heart path {
            stroke: $red;
            fill: $red;
            transition:
                stroke 0.25s ease-in-out,
                fill 0.25s ease-in-out;
        }
    }
</style>
